import { TYPES } from "../../common/constants";
import * as client from "../../services/client";
import { startFormLoading, stopFormLoading } from './loader';
import { toast } from 'react-toastify';
import { serviceRequestTableLocalTime } from "../../helpers/validationHelper";
export const addSuiteOnBoardingConveyanceFormListByPropertyCSV = (payload) => ({
  type: TYPES.ADD_SUITE_ONBOARDING_CONVEYANCE_FORM_LIST_BY_PROPERTY_CSV,
  payload,
});
export const getSuiteOnBoardingConveyanceFormListByPropertyCSV = (propertyId) => (dispatch) => {  
  dispatch(startFormLoading())
  return client.getSuiteOnBoardingConveyanceFormListByPropertyCSV(propertyId).then(response => {  
    dispatch(stopFormLoading())  
    if(response.ok || response.status === 200) {
      response.json().then(
        responsejson => {
          if(responsejson && responsejson.statusCode === 200) {
           const formData = responsejson.data
           let updatedformData= formData.map((item)=>{
            let obj=item;
            let date=serviceRequestTableLocalTime(item.date,'contacts')
            obj.dateTime =date
            return obj
           })
            dispatch(addSuiteOnBoardingConveyanceFormListByPropertyCSV(updatedformData))
          } else {
            toast.error(`🚫 Conveyance Form download failed, please try again.`,{autoClose:12000,position:'top-center'})
          }
        })
    } else {
      toast.error(`🚫 Conveyance Form download failed, please try again.`,{autoClose:12000,position:'top-center'})
  }
  })
  .catch(() => {
      toast.error(`🚫 Something went wrong , please try again.`,{autoClose:12000,position:'top-center'})
 })
 }
export const clearSuiteOnBoardingConveyanceFormListByPropertyCSV = () => ({
  type: TYPES.CLEAR_SUITE_ONBOARDING_CONVEYANCE_FORM_LIST_BY_PROPERTY_CSV,
});
